import { render, staticRenderFns } from "./HomeworkEditTab.vue?vue&type=template&id=1edff474&scoped=true&"
import script from "./HomeworkEditTab.vue?vue&type=script&lang=ts&"
export * from "./HomeworkEditTab.vue?vue&type=script&lang=ts&"
import style0 from "./HomeworkEditTab.vue?vue&type=style&index=0&id=1edff474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edff474",
  null
  
)

export default component.exports